import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import useResponsiveImageUrl from "src/utils/useResponsiveImageUrl";

const DATA_URL =
  "https://script.google.com/macros/s/AKfycbzgpQw7zMiATocgh7Lcu5QDjBxIgbfOg8MRkqk_eP7bD_CNMJcKc_ULdAMxJoKZ6zLp/exec";

const normalizePrizeData = (data) => {
  if (Array.isArray(data)) {
    return data;
  }

  if (data && typeof data === "object") {
    if (Array.isArray(data.prizeGrid)) {
      return data.prizeGrid;
    }

    if (Array.isArray(data.detectedPrizeData)) {
      return data.detectedPrizeData;
    }

    if (Array.isArray(data.prizes)) {
      return data.prizes;
    }

    if (Array.isArray(data.prizeData)) {
      return data.prizeData;
    }

    if (Array.isArray(data.data)) {
      return data.data;
    }

    if (Array.isArray(data.result)) {
      return data.result;
    }
  }

  return [];
};

const FreePlayPrizesMarch2026TV = () => {
  const [prizes, setPrizes] = useState([]);
  const backgroundImage = useResponsiveImageUrl("tv/free-play-prizes-bg-v2.jpg");

  useEffect(() => {
    const fetchPrizes = async () => {
      try {
        const timestamp = new Date().getTime();
        const response = await fetch(`${DATA_URL}?t=${timestamp}`);
        const data = await response.json();

        const normalized = normalizePrizeData(data);
        setPrizes(normalized);
      } catch (error) {
        console.error("Error fetching free play prizes:", error);
      }
    };

    fetchPrizes();

    const interval = setInterval(fetchPrizes, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <TVContainer>
      <BackgroundImage src={backgroundImage} alt="Free Play prizes background" />
      <PrizesOverlay>
        {prizes.map((prize, index) => (
          <PrizeValue key={index}>{prize.value}</PrizeValue>
        ))}
      </PrizesOverlay>
    </TVContainer>
  );
};

const TVContainer = styled.div`
  position: relative;
  height: 100vh;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background-color: #000;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BackgroundImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100vh;
  object-fit: cover;
  z-index: 0;
`;

const PrizesOverlay = styled.div`
  position: absolute;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  grid-template-rows: repeat(7, 1fr);
  top: 21.8%;
  left: 19.8%;
  width: 69.5%;
  height: 68%;
  gap: 0.55vw;

  @media (max-aspect-ratio: 16 / 9) {
    top: 20.5%;
    left: 20%;
    width: 76.8%;
    height: 58.7%;
    gap: 0.2vw;
  }
`;

const PrizeValue = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #111111;
  font-size: clamp(1rem, 1.8vw, 2.1rem);
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.03em;
`;

export default FreePlayPrizesMarch2026TV;